import React, { useCallback } from 'react'
import { Modal, Button } from 'antd'
import { TranslationKeys } from '../../Constants/TranslationKeys'
import { renderTranslation } from '../../Helpers/GenericHelpers'
import { toggleLimitChangeModal } from '../../Slices/Kiosk/ArticleDetailSlice'
import { useAppDispatch, useAppSelector } from '../../hooks'

function LimitChangeModal(props) {
  const dispatch = useAppDispatch()
  const language = useAppSelector(state => state.present.language.value)
  const limitChangeModal = useAppSelector(state => state.present.articleDetail.limitChangeModal)

  const onModalConfirm = useCallback(() => {
    props.onChangeConfirm()
    dispatch(toggleLimitChangeModal(false))
  }, [dispatch, props])

  const onModalCancel = useCallback(() => {
    props.onCancelConfirm()
    dispatch(toggleLimitChangeModal(false))
  }, [dispatch, props])

  return (
    <Modal
      title={renderTranslation(language, TranslationKeys.confirmChangeModalTitle)}
      open={limitChangeModal}
      closable={true}
      onCancel={e => {
        dispatch(toggleLimitChangeModal(false))
      }}
      width={400}
      footer={null}
      className={'confirm-change-modal'}
      getContainer={props.bodyref.current}
    >
      <div className='modal-body-text'>{renderTranslation(language, TranslationKeys.confirmChangeModalBody)}</div>
      <div className='modal-body-btn-box'>
        <Button className='btn confirm-btn' onClick={onModalConfirm}>
          {renderTranslation(language, TranslationKeys.confirmChangeModalConfirm)}
        </Button>
        <Button className='btn decline-btn' onClick={onModalCancel}>
          {renderTranslation(language, TranslationKeys.confirmChangeModalCancel)}
        </Button>
      </div>
    </Modal>
  )
}

export default LimitChangeModal
